import { Injectable, Inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { TranslateService } from '@ngx-translate/core';
import { Router } from '@angular/router';
import { BaseSubMaintenanceController } from '../../_base/BaseSubMaintenanceController';
import { UserMenuOptionListMaintenanceDto } from './UserMenuOptionListMaintenanceDto';
import { UserMenuOptionItemMaintenanceDto } from './UserMenuOptionItemMaintenanceDto';
import { AlertService } from '@shared/src/services/alert/alert.service';
import { LoadingService } from '@shared/src/public-api';

@Injectable()
export class UserMenuOptionSubMaintenanceController extends BaseSubMaintenanceController<UserMenuOptionListMaintenanceDto, UserMenuOptionItemMaintenanceDto> {

    constructor(
        protected http: HttpClient,
        @Inject('AlertService') protected alertService: AlertService,
        protected translateService: TranslateService,
        @Inject('LoadingService') protected loadingService: LoadingService,
        protected router: Router) {

        super(http, alertService, translateService, loadingService, router, "system/securityandnotifications/user/menuoption");
    }

    public getResourceRoot(): string {
        return "USER.MENUOPTION";
    }

    public buildUrl(parentId: number, optionParentid: string, uri: string): string {
        return "/system/securityandnotifications/user/" + parentId + "/" + optionParentid + "/submain" + uri;
    }
}